import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const destinations = [
  {
    id: "dakar",
    nom: "Dakar",
    pays: "Sénégal",
    desc: "La capitale vibrante — culture, gastronomie, plages et vie nocturne au bout de la presqu'île.",
    img: "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=800&q=80",
    type: "Capitale",
    highlight: "Île de Gorée · Corniche · Marché Sandaga",
    actif: true,
  },
  {
    id: "saly",
    nom: "Saly",
    pays: "Sénégal",
    desc: "La station balnéaire par excellence — plages de sable fin, resorts de luxe et eaux turquoise.",
    img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&q=80",
    type: "Balnéaire",
    highlight: "Plages · Resorts · Sports nautiques",
    actif: true,
  },
  {
    id: "saint-louis",
    nom: "Saint-Louis",
    pays: "Sénégal",
    desc: "Ville coloniale classée UNESCO, capitale du jazz et de la culture wolof sur une île du fleuve.",
    img: "https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=800&q=80",
    type: "Culture",
    highlight: "Pont Faidherbe · Festival Jazz · Langue de Barbarie",
    actif: false,
  },
  {
    id: "casamance",
    nom: "Casamance",
    pays: "Sénégal",
    desc: "Le Sénégal sauvage — forêts tropicales, mangroves, villages traditionnels et plages secrètes.",
    img: "https://images.unsplash.com/photo-1516026672322-bc52d61a55d5?w=800&q=80",
    type: "Nature",
    highlight: "Forêts · Mangroves · Cap Skirring",
    actif: false,
  },
  {
    id: "ziguinchor",
    nom: "Ziguinchor",
    pays: "Sénégal",
    desc: "Porte d'entrée de la Casamance, ville aux mille couleurs entre fleuve et forêt tropicale.",
    img: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&q=80",
    type: "Nature",
    highlight: "Marché artisanal · Pirogue · Biodiversité",
    actif: false,
  },
  {
    id: "thies",
    nom: "Thiès",
    pays: "Sénégal",
    desc: "La ville des tapisseries — centre artisanal et culturel du Sénégal, à 70km de Dakar.",
    img: "https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=800&q=80",
    type: "Culture",
    highlight: "Manufacture de tapisseries · Gare coloniale",
    actif: false,
  },
  {
    id: "touba",
    nom: "Touba",
    pays: "Sénégal",
    desc: "Ville sainte du mouridisme, lieu de pèlerinage majeur avec la Grande Mosquée.",
    img: "https://images.unsplash.com/photo-1564769662533-4f00a87b4056?w=800&q=80",
    type: "Spirituel",
    highlight: "Grande Mosquée · Magal · Artisanat",
    actif: false,
  },
  {
    id: "mbour",
    nom: "Mbour",
    pays: "Sénégal",
    desc: "Ville côtière animée, port de pêche traditionnel et point de départ vers la Petite Côte.",
    img: "https://images.unsplash.com/photo-1559494007-9f5847c49d94?w=800&q=80",
    type: "Balnéaire",
    highlight: "Port de pêche · Plages · Marché nocturne",
    actif: false,
  },
];

const typeColors = {
  Capitale:  { bg: "rgba(196,68,26,.1)",  color: "#C4441A" },
  Balnéaire: { bg: "rgba(26,107,139,.1)", color: "#1A6B8B" },
  Culture:   { bg: "rgba(139,105,20,.1)", color: "#8B6914" },
  Nature:    { bg: "rgba(61,107,46,.1)",  color: "#3D6B2E" },
  Spirituel: { bg: "rgba(107,61,139,.1)", color: "#6B3D8B" },
};

// ── Icônes ───────────────────────────────────────────────────
const IconPin = ({ size = 13, color = "#7A5A3A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const IconSearch = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#B8A898" strokeWidth="2" strokeLinecap="round">
    <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/>
  </svg>
);
const IconCheck = ({ size = 10, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);
const IconClock = ({ size = 10, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
  </svg>
);
const IconGlobe = ({ size = 13, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);
const IconMap = ({ size = 28, color = "#C4441A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21"/>
    <line x1="9" y1="3" x2="9" y2="18"/>
    <line x1="15" y1="6" x2="15" y2="21"/>
  </svg>
);
const IconArrowRight = ({ size = 14, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

// Icônes par type
const TypeIcon = ({ type, size = 13, color = "currentColor" }) => {
  if (type === "Capitale") return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
      <rect x="2" y="10" width="20" height="12" rx="1"/><path d="M12 2L2 10h20L12 2z"/>
      <rect x="9" y="14" width="6" height="8"/>
    </svg>
  );
  if (type === "Balnéaire") return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
      <path d="M2 20c2-2 4-3 6-3s4 1 6 3 4 3 6 3"/>
      <path d="M2 16c2-2 4-3 6-3s4 1 6 3"/>
      <path d="M12 3v8"/><path d="M8 5l4-2 4 2"/>
    </svg>
  );
  if (type === "Culture") return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
      <rect x="2" y="10" width="20" height="12" rx="1"/>
      <path d="M12 2L2 10h20L12 2z"/>
    </svg>
  );
  if (type === "Nature") return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
      <path d="M12 22V12"/><path d="M5 12c0-4 3-8 7-8s7 4 7 8"/>
      <path d="M5 17c0-2.5 3-4 7-4s7 1.5 7 4"/>
    </svg>
  );
  if (type === "Spirituel") return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round">
      <path d="M12 2L8 6H4v4l-2 2 2 2v4h4l4 4 4-4h4v-4l2-2-2-2V6h-4z"/>
    </svg>
  );
  return <IconGlobe size={size} color={color} />;
};

export default function Destinations() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filtre, setFiltre] = useState("Tous");

  const types = ["Tous", "Capitale", "Balnéaire", "Culture", "Nature", "Spirituel"];

  const destFiltrees = destinations.filter(d => {
    const matchSearch =
      d.nom.toLowerCase().includes(search.toLowerCase()) ||
      d.desc.toLowerCase().includes(search.toLowerCase()) ||
      d.type.toLowerCase().includes(search.toLowerCase());
    const matchType = filtre === "Tous" || d.type === filtre;
    return matchSearch && matchType;
  });

  return (
    <div style={{ fontFamily: "'Fraunces', serif", background: "#FAF5EC", color: "#1C1008", minHeight: "100vh" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }

        .dest-card {
          background: white; border-radius: 18px; overflow: hidden;
          border: 1.5px solid rgba(28,16,8,.06); cursor: pointer;
          transition: all .35s; display: flex; flex-direction: column;
        }
        .dest-card:hover { transform: translateY(-6px); box-shadow: 0 24px 56px rgba(28,16,8,.13); }
        .dest-card:hover .dest-img { transform: scale(1.05); }
        .dest-img { width: 100%; height: 220px; object-fit: cover; display: block; transition: transform .45s; }

        .type-btn {
          display: flex; align-items: center; gap: 6px;
          font-family: 'Space Grotesk', sans-serif; font-size: 13px; font-weight: 500;
          padding: 8px 16px; border-radius: 20px; border: 1.5px solid rgba(28,16,8,.12);
          background: white; color: #7A5A3A; cursor: pointer; transition: all .2s; white-space: nowrap;
        }
        .type-btn:hover { border-color: #C4441A; color: #C4441A; }
        .type-btn.active { background: #C4441A; color: white; border-color: #C4441A; }

        .btn-explorer {
          width: 100%; padding: 12px; background: #C4441A; color: white;
          border: none; border-radius: 10px; display: flex; align-items: center; justify-content: center; gap: 8px;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px; font-weight: 600;
          cursor: pointer; transition: all .3s;
        }
        .btn-explorer:hover { background: #A03614; }

        .btn-bientot {
          width: 100%; padding: 12px; background: #F0E8D4; color: #B8A898;
          border: none; border-radius: 10px;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px; font-weight: 600;
          cursor: not-allowed;
        }

        .search-input {
          flex: 1; border: none; outline: none;
          font-family: 'Space Grotesk', sans-serif; font-size: 14px;
          color: #1C1008; background: transparent; min-width: 0;
        }

        @keyframes fadeUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
        .fade-up { animation: fadeUp .5s ease forwards; }

        .dest-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
        @media(max-width:1199px) { .dest-grid { grid-template-columns: repeat(2, 1fr); } }
        @media(max-width:767px) {
          .dest-grid { grid-template-columns: 1fr; }
          .hero-dest { padding: 80px 5% 40px !important; }
          .filters-wrap { flex-wrap: wrap !important; }
        }
      `}</style>

      <Navbar transparent={false} />

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="hero-dest" style={{
        background: "linear-gradient(135deg, #1C1008 0%, #2D1A08 100%)",
        padding: "100px 5% 56px", position: "relative", overflow: "hidden",
      }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: "url(https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?w=1400&q=80)", backgroundSize: "cover", backgroundPosition: "center", opacity: .1 }} />
        <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle, rgba(196,68,26,.08) 1px, transparent 1px)", backgroundSize: "26px 26px" }} />

        <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
            <IconGlobe size={12} color="#C4441A" />
            <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, fontWeight: 700, letterSpacing: 3, color: "#C4441A", textTransform: "uppercase" }}>
              Explorez le Sénégal
            </p>
          </div>
          <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(28px,5vw,56px)", fontWeight: 800, color: "white", lineHeight: 1.1, letterSpacing: "-1.5px", marginBottom: 16 }}>
            Toutes les{" "}
            <span style={{ color: "#E8834A", fontStyle: "italic" }}>destinations</span>
          </h1>
          <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 16, color: "rgba(255,255,255,.6)", marginBottom: 36, maxWidth: 500 }}>
            De la capitale vibrante aux plages secrètes — découvrez les plus belles villes du Sénégal.
          </p>

          <div style={{ display: "flex", alignItems: "center", background: "white", borderRadius: 10, padding: "8px 8px 8px 20px", gap: 12, maxWidth: 520, boxShadow: "0 8px 32px rgba(0,0,0,.2)" }}>
            <IconSearch size={18} />
            <input
              className="search-input"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Rechercher une destination..."
            />
          </div>

          {/* Stats */}
          <div style={{ display: "flex", gap: 24, marginTop: 28, flexWrap: "wrap" }}>
            {[
              { val: destinations.length, label: "destinations" },
              { val: destinations.filter(d => d.actif).length, label: "actives" },
              { val: destinations.filter(d => !d.actif).length, label: "bientôt disponibles" },
            ].map((s, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "#E8834A" }}>{s.val}</span>
                <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "rgba(255,255,255,.5)" }}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FILTRES PAR TYPE ─────────────────────────────────── */}
      <section style={{ background: "white", borderBottom: "1px solid rgba(28,16,8,.07)", padding: "14px 5%", position: "sticky", top: 68, zIndex: 100 }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", alignItems: "center", gap: 10, overflowX: "auto", paddingBottom: 2 }} className="filters-wrap">
          {types.map(t => {
            const tc = typeColors[t];
            const isActive = filtre === t;
            return (
              <button key={t}
                className={`type-btn ${isActive ? "active" : ""}`}
                onClick={() => setFiltre(t)}
                style={{ flexShrink: 0 }}
              >
                <TypeIcon type={t} size={13} color={isActive ? "white" : (tc?.color || "#7A5A3A")} />
                {t === "Tous" ? "Toutes" : t}
              </button>
            );
          })}
        </div>
      </section>

      {/* ── GRILLE DESTINATIONS ──────────────────────────────── */}
      <section style={{ padding: "48px 5% 80px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>

          <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#7A5A3A", marginBottom: 28 }}>
            <strong style={{ color: "#1C1008" }}>{destFiltrees.length} destination{destFiltrees.length > 1 ? "s" : ""}</strong> trouvée{destFiltrees.length > 1 ? "s" : ""}
          </p>

          {destFiltrees.length === 0 && (
            <div style={{ textAlign: "center", padding: "80px 20px" }}>
              <div style={{ width: 72, height: 72, borderRadius: "50%", background: "rgba(196,68,26,.08)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                <IconGlobe size={36} color="#C4441A" />
              </div>
              <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 700, marginBottom: 10 }}>Aucune destination trouvée</h3>
              <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, color: "#7A5A3A", marginBottom: 20 }}>
                Essayez un autre mot-clé ou type.
              </p>
              <button onClick={() => { setSearch(""); setFiltre("Tous"); }}
                style={{ background: "#C4441A", color: "white", border: "none", padding: "12px 28px", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                Voir toutes les destinations
              </button>
            </div>
          )}

          <div className="dest-grid">
            {destFiltrees.map((d, i) => {
              const tc = typeColors[d.type] || typeColors["Culture"];
              return (
                <div key={d.id} className="dest-card fade-up" style={{ animationDelay: `${i * 0.07}s` }}>
                  <div style={{ overflow: "hidden", position: "relative", flexShrink: 0 }}>
                    <img className="dest-img" src={d.img} alt={d.nom} />
                    <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(28,16,8,.7) 0%, transparent 55%)" }} />

                    {/* Badge type */}
                    <div style={{ position: "absolute", top: 14, left: 14, background: tc.bg, backdropFilter: "blur(8px)", borderRadius: 6, padding: "4px 10px", border: `1px solid ${tc.color}30`, display: "flex", alignItems: "center", gap: 5 }}>
                      <TypeIcon type={d.type} size={11} color={tc.color} />
                      <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, color: tc.color }}>{d.type}</span>
                    </div>

                    {/* Badge actif / bientôt */}
                    <div style={{ position: "absolute", top: 14, right: 14, background: d.actif ? "rgba(61,107,46,.9)" : "rgba(28,16,8,.6)", backdropFilter: "blur(6px)", borderRadius: 6, padding: "4px 10px", display: "flex", alignItems: "center", gap: 5 }}>
                      {d.actif ? <IconCheck size={10} color="white" /> : <IconClock size={10} color="white" />}
                      <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, color: "white" }}>
                        {d.actif ? "Actif" : "Bientôt"}
                      </span>
                    </div>

                    {/* Nom sur l'image */}
                    <div style={{ position: "absolute", bottom: 16, left: 16 }}>
                      <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(20px,2.5vw,26px)", fontWeight: 800, color: "white", lineHeight: 1.1, marginBottom: 4 }}>
                        {d.nom}
                      </h2>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <IconPin size={11} color="rgba(255,255,255,.7)" />
                        <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "rgba(255,255,255,.7)" }}>{d.pays}</span>
                      </div>
                    </div>
                  </div>

                  {/* Contenu */}
                  <div style={{ padding: "18px 20px", flex: 1, display: "flex", flexDirection: "column", gap: 14 }}>
                    <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, color: "#7A5A3A", lineHeight: 1.7 }}>
                      {d.desc}
                    </p>

                    <div style={{ display: "flex", alignItems: "flex-start", gap: 6 }}>
                      <IconPin size={11} color="#B8A898" />
                      <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 12, color: "#B8A898", fontStyle: "italic", lineHeight: 1.6 }}>{d.highlight}</span>
                    </div>

                    <div style={{ marginTop: "auto" }}>
                      {d.actif
                        ? <button className="btn-explorer" onClick={() => navigate(`/destinations/${d.id}`)}>
                            Explorer {d.nom}
                            <IconArrowRight size={14} color="white" />
                          </button>
                        : <button className="btn-bientot" disabled>Bientôt disponible</button>
                      }
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── CTA ──────────────────────────────────────────────── */}
      <section style={{ background: "#F0E8D4", padding: "60px 5%", borderTop: "1px solid rgba(28,16,8,.07)" }}>
        <div style={{ maxWidth: 700, margin: "0 auto", textAlign: "center" }}>
          <div style={{ width: 56, height: 56, borderRadius: 14, background: "rgba(196,68,26,.1)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
            <IconMap size={28} color="#C4441A" />
          </div>
          <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: "clamp(22px,3.5vw,36px)", fontWeight: 800, letterSpacing: "-0.5px", marginBottom: 12 }}>
            Votre ville n'est pas encore là ?
          </h2>
          <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, color: "#7A5A3A", marginBottom: 28, lineHeight: 1.7 }}>
            SenuTour s'étend progressivement à toutes les régions du Sénégal. Suggérez une destination ou inscrivez votre établissement dès maintenant.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => navigate("/contact")}
              style={{ display: "flex", alignItems: "center", gap: 8, background: "#C4441A", color: "white", border: "none", padding: "13px 28px", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
              Suggérer une ville
              <IconArrowRight size={13} color="white" />
            </button>
            <button
              onClick={() => navigate("/inscription")}
              style={{ background: "transparent", color: "#1C1008", border: "1.5px solid rgba(28,16,8,.2)", padding: "12px 24px", borderRadius: 8, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
              Inscrire mon établissement
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}